import * as React from 'react';
import { Container, Grid } from '@mui/material';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import IconSumaAsegurada from '../../assets/img/detallesCotizacion/icono-suma-asegurada.svg';
import IconCoaseguro from '../../assets/img/detallesCotizacion/icono-coaseguro.svg';
import IconTopeCoaseguro from '../../assets/img/detallesCotizacion/icono-topecoaseguro.svg';
import IconNivelH from '../../assets/img/detallesCotizacion/icono-nivelhospitalario.svg';
import IconMarternidad from '../../assets/img/detallesCotizacion/icono-maternidad.svg';
import IconEmergenciaExtranjero from '../../assets/img/detallesCotizacion/icono-emergencia-extranjero.svg';
import IconCatastrofica from '../../assets/img/detallesCotizacion/icono-catastrofica.svg';
import LogoGNP from '../../assets/img/detallesCotizacion/logo-gnp.svg';
import './DetallesCotizacion.css'



export default function DetallesCotizacion(props) {

    const [planes, setPlanes] = React.useState('');
    const [modalidad, setModalidad] = React.useState('');

    const fondoStyle = {
        minHeight: "700px",
        height: "100%",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        backgroundColor: "#f4f4f4",
        // zIndex: "-50"
    }
    const bgWhite = {
        backgroundColor: "#FFF",
        padding: "2%",
        borderRadius: "12px",
        marginLeft: "10%",
        marginTop: "3%",
    }

    const handleChangeSelectPlanes = (event) => {
        setPlanes(event.target.value);
    };
    const handleChangeSelectModalidad = (event) => {
        setModalidad(event.target.value);
    };


    return (
        <div style={fondoStyle}>
            <a href='' className="m-15">Regresar a mis opciones</a>
            <div style={bgWhite} className="w-bgWhite">
                <Grid item xs={12} md={12}>
                    <img src={LogoGNP} className="mr-7"/>
                    <FormControl sx={{ m: 1, minWidth: 280 }}>
                        <InputLabel id="demo-simple-select-helper-label">Planes</InputLabel>
                        <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={planes}
                            label="Age"
                            onChange={handleChangeSelectPlanes}
                        >
                        </Select>
                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: 280 }}>
                        <InputLabel id="demo-simple-select-helper-label">Modalidad de pago</InputLabel>
                        <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={modalidad}
                            label="Age"
                            onChange={handleChangeSelectModalidad}
                        >
                        </Select>
                    </FormControl>
                </Grid>
                <Grid container className="bg-grey cont-beneficios">
                    <Grid item xs={1} md={1}>
                        <img src={IconSumaAsegurada} className="m-15"/> 
                    </Grid>
                    <Grid item xs={8} md={8}>
                        <p className="title-beneficios">suma asegurada</p>
                        <p className="p-beneficios">Es la cantidad máxima de dinero que paga la aseguradora en caso de que tengas un accidente o enfermedad.</p>
                    </Grid>
                    <Grid item xs={3} md={3} className="bg-beneficios">
                        <h3>$10,000,000</h3>
                    </Grid>
                </Grid>
                <Grid container className="bg-grey cont-beneficios">
                    <Grid item xs={1} md={1}>
                        <img /> icon
                    </Grid>
                    <Grid item xs={8} md={8}>
                        <p className="title-beneficios">Deducible</p>
                        <p className="p-beneficios"> Es el monto inicial fijo que debes cubrir para poder utilizar tu seguro en cada accidente o enfermedad.</p>
                    </Grid>
                    <Grid item xs={3} md={3} className="bg-beneficios">
                        <h3>$32,500</h3>
                    </Grid>
                </Grid>
                <Grid container className="bg-grey cont-beneficios">
                    <Grid item xs={1} md={1}>
                        <img src={IconCoaseguro} className="m-15"/> 
                    </Grid>
                    <Grid item xs={8} md={8}>
                        <p className="title-beneficios">Coaseguro</p>
                        <p className="p-beneficios">Es el porcentaje adicional que pagarás al descontar el deducible de tu accidente o enfermedad. Míralo así, si tu accidente fue de $100 y tu deducible de $10, con un coaseguro del 10% pagarás $9 adicionales. </p>
                    </Grid>
                    <Grid item xs={3} md={3} className="bg-beneficios">
                        <h3>10%</h3>
                        <p>por padecimiento</p>
                    </Grid>
                </Grid>
                <Grid container className="bg-grey cont-beneficios">
                    <Grid item xs={1} md={1}>
                        <img src={IconTopeCoaseguro} className="m-15"/> 
                    </Grid>
                    <Grid item xs={8} md={8}>
                        <p className="title-beneficios">Tope coaseguro</p>
                        <p className="p-beneficios">Es la cantidad máxima de dinero que deberás pagar de tu coaseguro por cada padecimiento. Es decir, que si tu accidente o enfermedad rebasa tu tope, ni te apures, la aseguradora cubrirá el resto.  </p>
                    </Grid>
                    <Grid item xs={3} md={3} className="bg-beneficios">
                        <h3>$71,000</h3>
                    </Grid>
                </Grid>
                <Grid container className="bg-grey cont-beneficios">
                    <Grid item xs={1} md={1}>
                        <img src={IconNivelH} className="m-15"/>
                    </Grid>
                    <Grid item xs={8} md={8}>
                        <p className="title-beneficios">Nivel hospitalario</p>
                        <p className="p-beneficios">Es la categoría de hospitales donde puedes atenderte, a partir del grado de tecnología y el número de especialidades que manejan. Imagina algo como una clasificación de 2 a 5 estrellas.</p>
                    </Grid>
                    <Grid item xs={3} md={3} className="bg-beneficios">
                        <h3>Incluido</h3>
                    </Grid>
                </Grid>
                <Grid container className="bg-grey cont-beneficios">
                    <Grid item xs={1} md={1}>
                        <img src={IconMarternidad} className="m-15"/>
                    </Grid>
                    <Grid item xs={8} md={8}>
                        <p className="title-beneficios">Maternidad</p>
                        <p className="p-beneficios">Es la cobertura para gastos de maternidad, siempre y cuando estés asegurada antes del embarazo.</p>
                    </Grid>
                    <Grid item xs={3} md={3} className="bg-beneficios">
                        <h3>$45,000</h3>
                    </Grid>
                </Grid>

                <div className="banderin-beneficios">Beneficios adicionales gratuitos</div>

                <Grid container className="cont-beneficios-adic">
                    <Grid item xs={1} md={1}>
                    <img src={IconEmergenciaExtranjero} className="m-15"/>
                    </Grid>
                    <Grid item xs={8} md={8}>
                        <p className="title-beneficios">Emergencia médica en el extranjero</p>
                        <p className="p-beneficios">Es la cobertura que tienes en caso de una emergencia médica en el extranjero que requiere atención en dicho país. Deseamos que no lo llegues a necesitar, ya que no hay nada como estar en casa.</p>
                    </Grid>
                    <Grid item xs={3} md={3} className="bg-beneficios-adic">
                        <h3>$63,000</h3>
                    </Grid>
                </Grid>
                <Grid container className="cont-beneficios-adic">
                    <Grid item xs={1} md={1}>
                        <img src={IconCatastrofica} className="m-15"/> 
                    </Grid>
                    <Grid item xs={8} md={8}>
                        <p className="title-beneficios">Enfermedades catastróficas nacional</p>
                        <p className="p-beneficios">Es la cobertura de enfermedades crónicas de alto riesgo en todos los hospitales de la república mexicana a un nivel por encima de tu plan contratado. Debemos estar preparados ante situaciones desafortunadas.</p>
                    </Grid>
                    <Grid item xs={3} md={3} className="bg-beneficios-adic">
                        <h3>$63,000</h3>
                    </Grid>
                </Grid>
            </div>
            <div>
                cotizacion
            </div>
        </div>
    )
}